import { Controller } from "@hotwired/stimulus"

// During blind writing each viewer sees only their own notes. To show that
// teammates are adding things, we render greyed placeholder cards for everyone
// else's notes: (total count) − (my own visible notes). It recomputes whenever
// the count badge or the notes list changes (both arrive via broadcasts), so it
// stays live without leaking note content.
export default class extends Controller {
  static targets = ["placeholders"]

  connect() {
    this.observer = new MutationObserver(() => this.render())
    this.observer.observe(this.element, { childList: true, subtree: true, characterData: true })
    this.render()
  }

  disconnect() {
    this.observer.disconnect()
  }

  render() {
    if (!this.hasPlaceholdersTarget) return

    const countEl = this.element.querySelector("[id^='count_']")
    const items = this.element.querySelector("[id^='items_']")
    if (!countEl || !items) return

    const total = parseInt(countEl.textContent.trim(), 10) || 0
    const own = items.querySelectorAll("[data-ticket-id]").length
    const others = Math.max(0, total - own)

    // Guard against re-triggering the observer in a loop.
    if (this.placeholdersTarget.children.length === others) return

    this.placeholdersTarget.innerHTML = Array.from({ length: others }, () => this.cardHTML()).join("")
  }

  cardHTML() {
    return `
      <div class="rounded-card border border-dashed border-line bg-mist p-3 animate-pulse" aria-hidden="true">
        <div class="h-2.5 w-2/3 rounded bg-line"></div>
        <div class="mt-2 h-2.5 w-1/3 rounded bg-line"></div>
      </div>`
  }
}
